import React, { Component } from 'react';
import { withRouter, Redirect } from 'react-router-dom'
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { InputText } from 'primereact/inputtext';
import { withNamespaces } from 'react-i18next';
import Modal from "react-responsive-modal";
class RejectFeedbackAnswerComponent extends Component {
    constructor(props) {
        super(props);
        this.state = {
            answersData:null||{},
            openAlarm: false
        }
          this.closeModal2 = this.closeModal2.bind(this);
    }
    rowClassName(rowData) {

        // let IsEnabled = rowData.IsEnabled;

        return { 'p-highlight': true };

    }
    rowExpansionTemplate = (data) => {
        var arraynew = [
            {
                "quesId": "",
                "ansId": "",
                "QuestionType": "",
                "Question": "",
                "Answer": "",
                "MissionId": "",
                "UpdatedDate": ""
            }
        ]
        let temp1 = data.answerList;
        for (let i = 0; i < temp1.length; i++) {
            if (arraynew.findIndex((element) => (element.quesId == temp1[i].QuestionId && element.MissionId == temp1[i].MissionId)) != -1) {
                let ind = arraynew.findIndex((element) => (element.quesId == temp1[i].QuestionId && element.MissionId == temp1[i].MissionId));
                arraynew[ind].ansId += ',' + temp1[i].AnswerId
                arraynew[ind].Answer += ' , ' + temp1[i].Answer

            }
            else {
                arraynew.push({
                    "quesId": temp1[i].QuestionId,
                    "ansId": temp1[i].AnswerId,
                    QuestionType: temp1[i].QuestionType,
                    Question: temp1[i].Question,
                    Answer: temp1[i].Answer,
                    MissionId: temp1[i].MissionId,
                    UpdatedDate: temp1[i].CreatedDate
                })
            }

        }
        arraynew.splice(0, 1);
        const { t } = this.props;
        return (
            <div className="orders-subtable">
                <DataTable 
                    className="table"
                    value={arraynew}
                    paginator={true} rows={10}
                    rowClassName={this.rowClassName}
                    responsiveLayout="scroll" 
                    emptyMessage={t('Feedback Setting.No records found')}
                >
                    <Column field="QuestionType" header={t('Feedback Setting.Question Type')} sortable={true} />
                    <Column field="Question" header={t('First_Responder.Question')} sortable={true} />
                    <Column field="Answer" header={t('First_Responder.Answer')} sortable={true} />
                    <Column field="MissionId" header={t('Setting.Mission Id')} sortable={true} />
                    <Column field="UpdatedDate" body={this.UpdatedDate} header='Updated Date' />
                </DataTable>
            </div>
        );
    }
    UpdatedDate(rowData) {
        if (rowData.UpdatedDate != null &&  rowData.UpdatedDate != undefined) {
            if(rowData.UpdatedDate == "0001-01-01T00:00:00"){
                return;
            }
            else{
                let value = rowData.UpdatedDate.split('T');
                let data = value[1].split(':');
                return (<p>{value[0] + " " + data[0] + ":" + data[1]}</p>) 
            }
        }
    }
    transformData(data) {
    
    /* let missions={};
     if(data)
     {
    data.forEach((user) => {
        const uid = user.UserId;
    
        const baseUser = {
          UserId: user.UserId,
          FirstName: user.FirstName,
          LastName: user.LastName,
          EmailId: user.EmailId,
          PhoneNumber: user.PhoneNumber,
          answerList: []
        };
    
        (user.answerList ? user.answerList : []).forEach((ans) => {
          const mid = (ans.MissionId ? ans.MissionId: "").trim();
         // const AlarmCategory=ans.AlarmCategory ? ans.AlarmCategory: ""
          if (!mid) return;
    
          if (!missions[mid]) {
           
            missions[mid] = { MissionId: mid,
              AlarmCategory:ans.AlarmCategory ? ans.AlarmCategory: "",
              PosLat:ans.PosLat ? ans.PosLat: null,
              PosLon:ans.PosLon ? ans.PosLon: null,
              AlarmCreatedDate:ans.AlarmCreatedDate ? ans.AlarmCreatedDate: null,
              AlarmUpdatedDate:ans.AlarmUpdatedDate ? ans.AlarmUpdatedDate: null,
              UserIds: {} };
          }
    
          if (!missions[mid].UserIds[uid]) {
            missions[mid].UserIds[uid] = { ...baseUser, answerList: [] };
          }
    
          missions[mid].UserIds[uid].answerList.push({
            QuestionId: ans.QuestionId,
            Question: ans.Question,
            QuestionType: ans.QuestionType,
            Answer: ans.Answer,
            CreatedDate:ans.CreatedDate
          });
        });
      });
    
      if(missions)
      {
      return Object.values(missions).map((m) => ({
        MissionId: m.MissionId,
         AlarmCategory:m.AlarmCategory ? m.AlarmCategory: "",
              PosLat:m.PosLat ? m.PosLat: null,
              PosLon:m.PosLon ? m.PosLon: null,
              AlarmCreatedDate:m.AlarmCreatedDate ? m.AlarmCreatedDate: null,
              AlarmUpdatedDate:m.AlarmUpdatedDate ? m.AlarmUpdatedDate: null,
              UserIds: Object.values(m.UserIds)
      }));
      }
    
     } */
      



     
let missions = {};

if (data) {
  data.forEach((user) => {
    const uid = user.UserId;

    const baseUser = {
      UserId: user.UserId,
      FirstName: user.FirstName,
      LastName: user.LastName,
      EmailId: user.EmailId,
      PhoneNumber: user.PhoneNumber,
      answerList: []
    };

    (user.answerList ? user.answerList : []).forEach((ans) => {
      const mid = (ans.MissionId ? ans.MissionId : "").trim();
      if (!mid) return;

      if (!missions[mid]) {
        missions[mid] = {
          MissionId: mid,
          AlarmCategory: ans.AlarmCategory ? ans.AlarmCategory : "",
          PosLat: ans.PosLat ? ans.PosLat : null,
          PosLon: ans.PosLon ? ans.PosLon : null,
          AlarmCreatedDate: ans.AlarmCreatedDate ? ans.AlarmCreatedDate : null,
          AlarmUpdatedDate: ans.AlarmUpdatedDate ? ans.AlarmUpdatedDate : null,
          UserIds: {}
        };
      }

      if (!missions[mid].UserIds[uid]) {
        missions[mid].UserIds[uid] = { ...baseUser, answerList: [] };
      }

      missions[mid].UserIds[uid].answerList.push({
        QuestionId: ans.QuestionId,
        Question: ans.Question,
        QuestionType: ans.QuestionType,
        Answer: ans.Answer,
        CreatedDate: ans.CreatedDate
      });
    });
  });

  if (missions) {
    return Object.values(missions)
      .map((m) => ({
        MissionId: m.MissionId,
        AlarmCategory: m.AlarmCategory || "",
        PosLat: m.PosLat || null,
        PosLon: m.PosLon || null,
        AlarmCreatedDate: m.AlarmCreatedDate || null,
        AlarmUpdatedDate: m.AlarmUpdatedDate || null,
        UserIds: Object.values(m.UserIds)
      }))
      .sort((a, b) => {
        const d1 = a.AlarmCreatedDate ? new Date(a.AlarmCreatedDate).getTime() : 0;
        const d2 = b.AlarmCreatedDate ? new Date(b.AlarmCreatedDate).getTime() : 0;
        return d2 - d1;  // DESCENDING (latest first)
      });
  }
}

    }
     closeModal2() {
        this.setState({ openAlarm: false });
      }
      rowExpansionTemplate = (data) => {
        /*   var arraynew = [
                {
                    "FirstName": "",
                    "LastName": "",
                    "EmailId": "",
                    "PhoneNumber": ""
                }
            ]
            let temp1 = data.UserList;
            for (let i = 0; i < temp1.length; i++) {
                if (arraynew.findIndex((element) => (element.quesId == temp1[i].QuestionId && element.MissionId == temp1[i].MissionId)) != -1) {
                    let ind = arraynew.findIndex((element) => (element.quesId == temp1[i].QuestionId && element.MissionId == temp1[i].MissionId));
                    arraynew[ind].ansId += ',' + temp1[i].AnswerId
                    arraynew[ind].Answer += ' , ' + temp1[i].Answer
    
                }
                else {
                    arraynew.push({
                        "quesId": temp1[i].QuestionId,
                        "ansId": temp1[i].AnswerId,
                        QuestionType: temp1[i].QuestionType,
                        Question: temp1[i].Question,
                        Answer: temp1[i].Answer,
                        MissionId: temp1[i].MissionId,
                        UpdatedDate: temp1[i].CreatedDate
                    })
                }
    
            }
            arraynew.splice(0, 1);
            console.log("arraynew", arraynew); */
        const { t } = this.props;
        return (
          <div className="orders-subtable">
            <DataTable
              className="table"
              value={data.UserIds}
              paginator={true}
              rows={10}
              rowClassName={this.rowClassName}
              responsiveLayout="scroll"
              emptyMessage={t("Feedback Setting.No records found")}
              rowExpansionTemplate={this.rowExpansionTemplate}
              onRowToggle={(e) => this.setState({ expandedRows1: e.data })}
              expandedRows={this.state.expandedRows1}
            >
              <Column
                field="FirstName"
                header={t("First_Responder.First Name")}
                sortable={true}
              />
              <Column
                field="LastName"
                header={t("First_Responder.Last Name")}
                sortable={true}
              />
              <Column
                field="EmailId"
                header={t("First_Responder.Email")}
                sortable={true}
              />
              <Column
                field="PhoneNumber"
                header={t("First_Responder.Phone Number")}
                sortable={true}
              />
    
              <Column
                headerClassName="hideheader"
                body={(e) => this.actionColumn2(e)}
                header="Logs"
              />
            </DataTable>
          </div>
        );
      };
      UpdatedDate(rowData) {
        if (rowData.UpdatedDate != null && rowData.UpdatedDate != undefined) {
          if (rowData.UpdatedDate == "0001-01-01T00:00:00") {
            return;
          } else {
            let value = rowData.UpdatedDate.split("T");
            let data = value[1].split(":");
            return <p>{value[0] + " " + data[0] + ":" + data[1]}</p>;
          }
        }
      }
      formatMissionUsersCount(rowData) {
        if(rowData)
        {
 if (rowData? rowData.UserIds.length != 0:null) {
          return <p>{rowData.UserIds.length}</p>;
        } else {
          return <p>0</p>;
        }
        }
       
      }
      formatAnswersCount(rowData) {
        if(rowData)
        {
  if (rowData.answerList.length != 0) {
          return <p>{rowData.answerList.length}</p>;
        } else {
          return <p>0</p>;
        }
        }
      
      }
      actionColumn2(rowDatas) {
        const { t } = this.props;
        return (
          <span>
            <span
              onClick={() => {
                this.openModal2(rowDatas);
              }}
              className="enable-cursor editicon"
              title={t("First_Responder.Log")}
            >
              <i className="fa fa-history" aria-hidden="true"></i>
            </span>
          </span>
        );
      }
      openModal2(rowDatas) {
        
        this.state.answersData=rowDatas ? rowDatas.answerList:[];
        this.setState({answersData:rowDatas ? rowDatas.answerList:[]})
        this.setState({ openAlarm: true });
      }
       formatCreatedDate(rowData) {
            if (rowData.CreatedDate != null && rowData.CreatedDate != undefined) {
                if (rowData.CreatedDate == "0001-01-01T00:00:00") {
                    return;
                }
                else {
                    let value = rowData.CreatedDate.split('T');
                   
                    let data = value[1].split(':');
                    let sec=data[2].split('.')
                    return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
                }
            }
        }
         formatUpdatedDate1(rowData) {
            if (rowData.UpdatedDate != null && rowData.UpdatedDate != undefined) {
                if (rowData.UpdatedDate == "0001-01-01T00:00:00") {
                    return;
                }
                else {
                    let value = rowData.UpdatedDate.split('T');
                    let data = value[1].split(':');
                     let sec=data[2].split('.')
                    return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
                }
            }
        }
         formatUserPos(rowData) {
            if (rowData.PosLat && rowData.PosLon) {
    
                return (<p>{rowData.PosLat}, {rowData.PosLon}</p>)
    
            }
            else{
                return
            }
        }
         formatCreatedDate2(rowData) {
            if (rowData.AlarmCreatedDate != null && rowData.AlarmCreatedDate != undefined) {
                if (rowData.AlarmCreatedDate == "0001-01-01T00:00:00") {
                    return;
                }
                else {
                    let value = rowData.AlarmCreatedDate.split('T');
                   
                    let data = value[1].split(':');
                    let sec=data[2].split('.')
                    return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
                }
            }
        }
         formatUpdatedDate2(rowData) {
            if (rowData.AlarmUpdatedDate != null && rowData.AlarmUpdatedDate != undefined) {
                if (rowData.AlarmUpdatedDate == "0001-01-01T00:00:00") {
                    return;
                }
                else {
                    let value = rowData.AlarmUpdatedDate.split('T');
                    let data = value[1].split(':');
                     let sec=data[2].split('.')
                    return (<p>{value[0] + " " + data[0] + ":" + data[1] + ":" + sec[0]}</p>)
                }
            }
        }
    render() {
        const { t } = this.props;
         var updatedAlarmStatusListData = [];
    updatedAlarmStatusListData =
      this.props.feedbackAnswerList.alarmReceiverList;
      
        var header = <div className="search-name">
            <i className="fa fa-search" style={{ margin: '4px 4px 0 0' }}></i>
            <InputText type="text" onInput={(e) => this.setState({ globalFilter: e.target.value })} placeholder={t('First_Responder.Search')} size="50" />
        </div>;
        return (
            <div>
                <div className="progressbar-heading grids-heading">
                    <h2>{t('Feedback Setting.Reject Feedback answer list')}</h2>
                </div>
                <div className=" forms-panel w3-last-form">
                    <div className="forms add-device">
                        <div className="form-three widget-shadow">
                            <div className=" panel-body-inputin">

                                <div className="w3l_search">
                                    {header}
                                </div>
                                <div className="devicestable">
                                    <br />

                                    <DataTable
                                        className="table"
                                        value={this.transformData(this.props.feedbackAnswerList.answerList)}
                                        loading={this.props.feedbackAnswerList.isLoading}
                                        paginator={true} rows={10}
                                        globalFilter={this.state.globalFilter}
                                        emptyMessage={t('Feedback Setting.No records found')}
                                        rowExpansionTemplate={this.rowExpansionTemplate}
                                        onRowToggle={(e) => this.setState({ expandedRows: e.data })}
                                        expandedRows={this.state.expandedRows}
                                    >
                                          <Column expander style={{ width: "3em" }} />
                                       
                                                           <Column
                                                             field="MissionId"
                                                             header="MissionId"
                                                             className="wordBreakLine"
                                                           />
                                                            <Column
                                                                                 field="AlarmCategory"
                                                                                 header="Alarm Category"
                                                                                 className="wordBreakLine"
                                                                               />
                                                                                <Column field="Phone" header="Position" body={this.formatUserPos} sortable={true} className="wordBreakLine" />
                                                                                <Column field="CreatedDate" body={this.formatCreatedDate2} header={t('First_Responder.Created Date')} sortable={true} className="wordBreakLine" />
                                                                                 <Column field="UpdatedTime" header={t('First_Responder.Status Update Time')} body={this.formatUpdatedDate2} sortable={true} className="wordBreakLine"></Column>
                                                         {/*   <Column
                                                             field="AlarmCategory"
                                                             header="Alarm Category"
                                                             className="wordBreakLine"
                                                           />
                                                            <Column field="Phone" header="Position" body={this.formatUserPos} sortable={true} className="wordBreakLine" />
                                                            <Column field="CreatedDate" body={this.formatCreatedDate} header={t('First_Responder.Created Date')} sortable={true} className="wordBreakLine" />
                                                             <Column field="UpdatedTime" header={t('First_Responder.Status Update Time')} body={this.formatUpdatedDate1} sortable={true} className="wordBreakLine"></Column> */}
                                                          
                                                           <Column
                                                             field="StatusUpdatedDate"
                                                             header="Total Users"
                                                             body={this.formatMissionUsersCount}
                                                             className="wordBreakLine"
                                                           />
                                    </DataTable>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                 <Modal
          open={this.state.openAlarm}
          onClose={this.closeModal2}
          center
          classNames={{ modal: "UpdateAlarmStatusModal" }}
        >
          <div className="">
            <div className="progressbar-heading grids-heading">
              <h2>{t('Reject Feedback Answer Logs')}</h2>
            </div>

            <div className="">
              <div className="forms add-device setting-panel">
                <div className="widget-shadow">
                  <div className=" panel-body-inputin">
                    <DataTable
                      value={this.state.answersData}
                      responsiveLayout="scroll"
                     
               
                      emptyMessage={t("Feedback Setting.No records found")}
                    >
                      {/* <Column field="FirstName" header={t('First_Responder.Patient Name')} body={this.patientFullname} sortable={true} /> */}
                      <Column
                        field="QuestionType"
                        header={t("Feedback Setting.Question Type")}
                        sortable={true}
                      />
                      <Column
                        field="Question"
                        header={t("First_Responder.Question")}
                        sortable={true}
                      />
                      <Column
                        field="Answer"
                        header={t("First_Responder.Answer")}
                        sortable={true}
                      />
                     
                      
                     <Column field="CreatedDate" body={this.formatCreatedDate} header="Updated Date" sortable={true} className="wordBreakLine" />

                    </DataTable>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
            </div>
        )
    }
}
export default withNamespaces()(withRouter(RejectFeedbackAnswerComponent));
